import rbl, { collect } from '@/assets/lib/ga'

rbl.collect = collect
global.$rbl = rbl
